import {AbstractEvent} from "@/modules/base/events";
import {Matchday} from "@/modules/competitions/entity";

export class AfterMatchdayEvaluation extends AbstractEvent {
  constructor(
    public matchday: Matchday
  ) {
    super();
  }
}